import { Image as TiptapImage } from '@tiptap/extension-image';
import { mergeAttributes } from '@tiptap/core';

export const CustomImage = TiptapImage.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: element => element.getAttribute('width'),
        renderHTML: attributes => {
          if (!attributes.width) {
            return {};
          }
          return {
            width: attributes.width,
          };
        },
      },
      height: {
        default: null,
        parseHTML: element => element.getAttribute('height'),
        renderHTML: attributes => {
          if (!attributes.height) {
            return {};
          }
          return {
            height: attributes.height,
          };
        },
      },
    };
  },

  addNodeView() {
    return ({ node, getPos, editor }) => {
      const container = document.createElement('div');
      container.className = 'image-container relative group';
      
      const img = document.createElement('img');
      img.src = node.attrs.src;
      img.alt = node.attrs.alt || 'Blog image';
      img.className = 'w-full h-auto rounded-lg my-6 block mx-auto shadow-lg transition-transform duration-200 hover:scale-105';
      img.style.cssText = 'width: 100%; height: auto; display: block; margin-left: auto; margin-right: auto; object-fit: cover;';
      
      // Add loading state
      img.onload = () => {
        img.style.opacity = '1';
      };
      img.style.opacity = '0.7';
      img.style.transition = 'opacity 0.3s ease';
      
      container.appendChild(img);
      
      // Add delete button
      const deleteButton = document.createElement('button');
      deleteButton.innerHTML = '×';
      deleteButton.className = 'absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold hover:bg-red-600 transition-colors opacity-0 group-hover:opacity-100 z-10';
      deleteButton.title = 'Delete image';
      deleteButton.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const pos = getPos();
        if (pos !== undefined) {
          editor.chain().focus().deleteRange({ from: pos, to: pos + node.nodeSize }).run();
        }
      };
      container.appendChild(deleteButton);
      
      // Add resize handles on selection
      const updateSelection = () => {
        const { from, to } = editor.state.selection;
        const pos = getPos();
        if (pos !== undefined && from <= pos && to >= pos + node.nodeSize) {
          container.classList.add('selected');
        } else {
          container.classList.remove('selected');
        }
      };
      
      editor.on('selectionUpdate', updateSelection);
      updateSelection();
      
      return {
        dom: container,
        update: (updatedNode) => {
          if (updatedNode.type !== node.type) {
            return false;
          }
          img.src = updatedNode.attrs.src;
          img.alt = updatedNode.attrs.alt || 'Blog image';
          return true;
        },
        destroy: () => {
          editor.off('selectionUpdate', updateSelection);
        },
      };
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'img',
      mergeAttributes(
        {
          class: 'w-full h-auto rounded-lg my-6 block mx-auto',
          style: 'max-width: 100%; height: auto; display: block; margin-left: auto; margin-right: auto;',
        },
        HTMLAttributes
      ),
    ];
  },
});
